import cn from 'classnames';
import { Icon, IconProps, Tooltip } from '@economic/taco';
import React from 'react';
import { EntryType, EntryTypeToIconColor, EntryTypeToIconName, getEntryTooltipNames } from '~/types';

type EntryIconProps = {
    entryType: EntryType;
    hideTooltip?: boolean | undefined;
} & Omit<IconProps, 'name'>;

export function EntryTypeIcon({ entryType, hideTooltip, className, ...iconProps }: EntryIconProps) {
    const icon = EntryTypeToIconName[entryType] || 'entry-type-journal-entry';
    const color = EntryTypeToIconColor[entryType] || 'text-blue-300';

    if (hideTooltip) {
        return <Icon name={icon} className={cn(color, className)} {...iconProps} />;
    }

    return (
        <Tooltip title={getEntryTooltipNames(entryType)}>
            <Icon name={icon} className={cn(color, className)} {...iconProps} />
        </Tooltip>
    );
}
